// extracted by mini-css-extract-plugin
export default {"sponsorsContainer":"sponsors_sponsorsContainer__yC4oG"};